export const create = {
  createSuccessfully: 'Create new terminal successfully!',
}
